import React from 'react';
import { useParams } from 'react-router-dom';

import MoodBoard from '@components/moodboard/MoodBoard';

const CollectionRequestContainer = () => {
	const { id } = useParams();
	return (
		<div>
			<MoodBoard moodboardId={id} isShowTop={true} />
		</div>
	);
};

export default CollectionRequestContainer;
